export default __webpack_public_path__ + "static/media/ifce-maracanau-entrada.c4e59473.png";